export default __webpack_public_path__ + "static/product3-bb38f049cc9606ef9aaf71492d8ff9b2.jpg";